import { createPortfolioImage, getPortfolioImages } from 'slices/portfolioImagesSlice'
import { createPortfolioNote } from 'slices/portfolioNoteSlice'
import { patchPortfolio } from 'slices/portfolioSlice'
import type { ImageNoteAdapter } from '../commitImageUpload'
import { resolveImageType } from './locationImageAdapter'

export interface PortfolioImageAdapterArgs {
	dispatch: any
	userId: string
	portfolioId: string
}

/**
 * Portfolio-level images and notes.
 *
 * PortfolioNote has no `parentid` field, so unlike the location adapter this
 * one must not send it — Mongoose would drop it, but sending a field the schema
 * does not model invites the same confusion the portfolio notes screen carries
 * a note about.
 */
export const portfolioImageAdapter = ({
	dispatch,
	userId,
	portfolioId,
}: PortfolioImageAdapterArgs): ImageNoteAdapter => ({
	createImageRow: async ({ image, note }) => {
		await dispatch(
			(createPortfolioImage as any)({
				userid: userId,
				portfolioid: portfolioId,
				uuid: image.upload.public_id,
				name: image.normalized.name ?? image.file.name,
				size: image.upload.bytes ?? 0,
				url: image.upload.secure_url,
				source: image.normalized.source ?? 'cloudinary',
				type: resolveImageType(image),
				note,
			}),
		).unwrap()
	},

	createNoteRow: async ({ html }) => {
		await dispatch(
			(createPortfolioNote as any)({
				userid: userId,
				portfolioid: portfolioId,
				note: html,
			}),
		).unwrap()
	},

	afterCommit: async () => {
		dispatch((patchPortfolio as any)({ portfolioId, updates: { updateNote: 'Image(s) Updated' } }))
		// Refetches only the portfolio image slice. getImages would clobber the
		// location gallery's ids, which it replaces wholesale.
		await dispatch((getPortfolioImages as any)(portfolioId))
	},
})

export default portfolioImageAdapter
